<template>
  <div v-if="links.length > 3" class="pagination">
    <div class="flex flex-wrap -mb-1" v-if="!isJSON">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded" v-html="link.label" />
        <Link v-else :key="`link-${key}`" class="mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:bg-white border focus:border-indigo-500 rounded" :class="{ 'activePage': link.active, 'inactivePage': !link.active }" :href="link.url" v-html="link.label" />
      </template>
    </div>
    <div class="flex flex-wrap -mb-1" v-if="isJSON">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded" v-html="link.label" style="cursor:not-allowed;"/>
        <div v-else :key="`link-${key}`" class="mb-1 mr-1 px-4 py-3 text-sm leading-4 rounded" :class="{ 'activePage': link.active, 'inactivePage': !link.active }" @click="$emit('pageClick',link)" v-html="link.label" style="cursor:pointer"/>

      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'

export default {
  components: {
    Link,
  },
  props: {
    links: Array,
    isJSON: { default: false, type: Boolean }
  },
}
</script>
<style type="text/css">
  .pagination .inactivePage {
    border: 1px solid #560354;
    color: #560354;
    background-color: #fff;
  }
  .pagination .activePage {
    border: 1px solid #ccc;
    color: #fff;
    background-color: #560354;
  }

</style>

